import { motion } from 'framer-motion';
import { Redirect, RedirectProps } from 'react-router-dom';

export function MotionRedirect(props: RedirectProps): JSX.Element {
  return (
    <motion.div exit="undefined">
      <Redirect {...props} />
    </motion.div>
  );
}

export default MotionRedirect;
